import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  iniciarAplicacionService,
  getActividadActualService,
  guardarRespuestasService,
  getEstadoAplicacionService,
  getResumenAplicacionService,
} from "../../services/quiz-aplication/aplicaciontalentos.service";

export const iniciarAplicacionThunk = createAsyncThunk(
  "aplicacionTalentos/iniciar",
  async (_, { rejectWithValue }) => {
    try {
      const response = await iniciarAplicacionService();
      // El servicio hace apiBase.post() → axios devuelve response.data (el body completo)
      // Ese body tiene { message, data: { id, estado, talento_actual, ... }, status_code }
      // Así que necesitamos response.data (el campo data del body)
      return response?.data ?? response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al iniciar la aplicación",
      );
    }
  },
);

export const getActividadActualThunk = createAsyncThunk(
  "aplicacionTalentos/actividadActual",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getActividadActualService();
      // Este endpoint devuelve directamente { talento, actividad, frases, ... }
      // sin wrapper { data: ... }, así que devolvemos tal cual
      return response?.data ?? response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener la actividad",
      );
    }
  },
);

export const guardarRespuestasThunk = createAsyncThunk(
  "aplicacionTalentos/guardarRespuestas",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await guardarRespuestasService(payload);
      return response?.data ?? response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al guardar las respuestas",
      );
    }
  },
);

export const getEstadoAplicacionThunk = createAsyncThunk(
  "aplicacionTalentos/estado",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getEstadoAplicacionService();
      return response?.data ?? response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener el estado",
      );
    }
  },
);

export const getResumenAplicacionThunk = createAsyncThunk(
  "aplicacionTalentos/resumen",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getResumenAplicacionService();
      return response?.data ?? response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener el resumen",
      );
    }
  },
);
